import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import VueRouter from 'vue-router';
import FormSelect from 'bootstrap-vue/es/components/form-select'
import {routes} from './routes';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/_global.scss'
import { getCookie } from "./cookie.js";
import firebaseMessaging from './firebase'

Vue.prototype.$messaging = firebaseMessaging;
Vue.use(FormSelect);
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.use(VueRouter)
const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = getCookie('user')
  if (authRequired && !loggedIn) {
    // console.log('not authorized')
    return next('/login')
  }
  next()
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
